import { LuxCtaGroupWrapperConfig, LuxCtaGroupConfig } from '@lux/wardrobe-lib'
import {
    canEditAlbum,
    canGalleryPhotoPublish,
    canGalleryPhotoSendInApproval,
    canPhotoApproval,
    canPhotoPublish,
    canPhotoReject,
    canPhotoSendInApproval,
    SmartlyActionItems,
} from '@Techedge/digitalportal-shared'
import { SavePictureActions } from '../redux/actions/save-picture'
import { IPhotoDetails } from './photo'

export const getCtaConfig = (details: IPhotoDetails, intl) => {
    const model: any = {
        type: 'photographic',
        status: details.status,
        creatorUserInfo: details.creatorUserInfo,
        childrenSubType: details.project?.childrenSubType,
    }

    if (details.project) model.projectId = details.project.id

    return new LuxCtaGroupWrapperConfig({
        left: [
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'gallery.detail.download_button',
                    defaultMessage: 'Download',
                }),
                defaultLabel: 'Download photos',
                action: SavePictureActions.DOWNLOAD,
                permission: () => true,
                icon: 'download',
                variant: 'outline',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.add.to.package',
                    defaultMessage: 'Add to package',
                }),
                defaultLabel: 'Add to Package',
                action: SavePictureActions.ADD_TO_PACKAGE,
                // permission: () => !!details?.store?.storeId,
                permission: () => false,
                icon: 'file-plus',
                variant: 'outline',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.add.to.album',
                    defaultMessage: 'Add to album',
                }),
                defaultLabel: 'Add to Album',
                action: SavePictureActions.ADD_TO_ALBUM,
                permission: () => canEditAlbum(),
                // permission: () => true,
                icon: 'folder-plus',
                variant: 'outline',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.delete.from.picstore',
                    defaultMessage: 'Delete from PicStore',
                }),
                defaultLabel: 'Delete from PicStore',
                action: SavePictureActions.DELETE_FROM_PICSTORE,
                permission: () => true, // TO ADD PERMISSION
                icon: 'trash',
                variant: 'outline',
            }),
        ],
        right: [
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.send.in.approval',
                    defaultMessage: 'Send in Approval',
                }),
                defaultLabel: 'Send in Approval',
                action: SavePictureActions.SEND_IN_APPROVAL,
                permission: () => canPhotoSendInApproval(model),
                icon: 'check-circle',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.stop',
                    defaultMessage: 'Stop',
                }),
                defaultLabel: 'Stop',
                action: SavePictureActions.STOP,
                permission: () => canPhotoReject(model),
                model,
                subject: SmartlyActionItems.TASK,
                icon: 'exclamation-triangle',
                variant: 'outline',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.go',
                    defaultMessage: 'Go',
                }),
                defaultLabel: 'Go',
                action: SavePictureActions.GO,
                permission: () => canPhotoApproval(model),
                model,
                subject: SmartlyActionItems.TASK,
                icon: 'check-circle',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.publish',
                    defaultMessage: 'Publish',
                }),
                defaultLabel: 'Publish',
                action: SavePictureActions.PUBLISH,
                permission: () => canPhotoPublish(model),
                model,
                subject: SmartlyActionItems.TASK,
                icon: 'send',
            }),
        ],
    })
}

export const getCtaNewPhotoConfig = (intl) => {
    const model: any = {
        type: 'photographic',
    }

    return new LuxCtaGroupWrapperConfig({
        left: [
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.modals.photo.retake',
                    defaultMessage: 'Retake photo',
                }),
                defaultLabel: 'Retake photo',
                action: SavePictureActions.RETAKE_PHOTO,
                permission: () => true,
                variant: 'text',
            }),
        ],
        right: [
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.send.in.approval',
                    defaultMessage: 'Send in Approval',
                }),
                defaultLabel: 'Send in Approval',
                action: SavePictureActions.SAVE_AND_SEND_IN_APPROVAL,
                permission: () => canGalleryPhotoSendInApproval(model),
                subject: SmartlyActionItems.TASK,
                icon: 'check-circle',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.gallery.detail.publish',
                    defaultMessage: 'Publish',
                }),
                defaultLabel: 'Publish',
                action: SavePictureActions.SAVE_AND_PUBLISH,
                permission: () => canGalleryPhotoPublish(model),
                model,
                subject: SmartlyActionItems.TASK,
                icon: 'send',
            }),
            new LuxCtaGroupConfig({
                label: intl.formatMessage({
                    id: 'ph2.modals.photo.save',
                    defaultMessage: 'Save',
                }),
                defaultLabel: 'Save',
                action: SavePictureActions.SAVE,
                permission: () => true,
                model,
                subject: SmartlyActionItems.TASK,
                icon: 'picture',
            }),
        ],
    })
}
